module.exports = __webpack_public_path__ + "img/cry.21ed3c01.gif";